import { DataLayer } from '@grandvisionhq/analytics';
import { myAccountEventType } from './types.js';

const logCreateAccountEvent = (event)=>{
    DataLayer.pushEvent({
        event_type: myAccountEventType,
        event: event.type
    });
};

export { logCreateAccountEvent };
//# sourceMappingURL=create-account.js.map
